import * as React from "react";
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import Particles from "@tunnel-components/@sharded/widgets/particules/component";
import ButtonGrid from "@tunnel-components/@sharded/widgets/forms/input/button/custom/component";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import Icons from "@tunnel-components/@sharded/@widgets/icons/component";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onChangeValue,
    onSubmitValues,
    submitSend,
    warning,
    error,
    success,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-router-dom
   * @infos "https://reactjs.org"
   */
  return (
    <div className="authentification-overlay ">
      <Particles>
        <div className="authentification">
          <form className="authente-box" onSubmit={onSubmitValues}>
            <div className="logo-apps">
              <Link to={Paths.PathsNamesEnums.LOGIN}>
                <div className="logo-user" />
              </Link>
            </div>

            <div className="login-infos">
              <div className="box-form ">
                <p className="forget-pwd " style={{ textAlign: "center" }}>
                  {i18next.t("pour reinitialiser votre mot de passe")}
                </p>
              </div>
              <div className="box-form ">
                <StyledComponent.Container>
                  <StyledComponent.ContainerInput
                    error={warning || error}
                    style={{ borderRadius: "5px" }}
                  >
                    <StyledComponent.Input
                      title={i18next.t("saisisser votre email")}
                      style={{ paddingRight: "45px", boxSizing: "border-box" }}
                      type="email"
                      name="email"
                      required={true}
                      // value={email}
                      placeholder={i18next.t("saisisser votre email")}
                      autoComplete="off"
                      onChange={onChangeValue}
                    />
                    <StyledComponent.Icon style={{ width: "18px" }}>
                      <Icons user={true} color="#b6b3b3" />
                    </StyledComponent.Icon>
                  </StyledComponent.ContainerInput>
                </StyledComponent.Container>
              </div>

              <StyledComponent.BoxForms isVisible={!submitSend}>
                <div className="box-form">
                  <div
                    style={{ position: "absolute", width: "auto", right: "0" }}
                  >
                    <ButtonGrid
                      onSubmit={!success ? onSubmitValues : undefined}
                      text={i18next.t("reinitialiser")}
                    />
                  </div>
                </div>
              </StyledComponent.BoxForms>
              <StyledComponent.BoxForms isVisible={submitSend}>
                <div className="actionLoader" style={{ marginTop: "10px" }}>
                  <div className="lds-spinner">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              </StyledComponent.BoxForms>
            </div>
          </form>
        </div>

        <SnackBar
          style={{
            backgroundColor: "#00E1B3",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={success && !warning && !error}
          someTextSuccees={i18next.t(
            "un mail vous sera envoyé pour réinitialiser votre mot de passe"
          )}
        />
        <SnackBar
          style={{
            backgroundColor: "#ED5B56",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={warning && !error}
          someTextSuccees={i18next.t("format du mail errone")}
        />
        <SnackBar
          style={{
            backgroundColor: "#ED5B56",
            left: "50%",
            right: "unset",
            transform: "translate(-50%,0)",
          }}
          isVisible={error && !warning && !success}
          someTextSuccees={i18next.t("probleme avec l'envoi du mail")}
        />
      </Particles>
    </div>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {
  error: false,
  warning: false,
  submitSend: true,
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onChangeValue?: React.EventHandler<React.ChangeEvent<HTMLInputElement>>;
  onSubmitValues?: React.EventHandler<any>;
  loading?: any;
  warning?: any;
  error?: boolean;
  success?: boolean;
  setTime?: any;
  onToggleTunnelWatchInfos?: any;
  tunnelWatchInfos?: boolean;
  submitSend?: boolean;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/fogetPassword/component.tsx